export default __webpack_public_path__ + "static/A08-85f3d941b901270b8e0fd90a1a93888c.jpg";